import HelperFunctions from '../../global/HelperFunctions';
import { getName, getNames, registerLocale } from '@cospired/i18n-iso-languages';
import localeNL from '@cospired/i18n-iso-languages/langs/nl.json';
import localeEN from '@cospired/i18n-iso-languages/langs/en.json';

registerLocale(localeNL);
registerLocale(localeEN);

const appLocale = 'nl';

export function getLanguageOptions(lang: string) {
    const allLanguagesAsObject = getNames(lang ?? appLocale);

    return Object.keys(allLanguagesAsObject)
        .map((key) => {
            return {
                value: key,
                label: allLanguagesAsObject[key],
            };
        })
        .sort(HelperFunctions.sortByString('label'));
}

export function getLanguageName(languageIso: string) {
    return getName(languageIso, appLocale);
}
